import { GraduationCap, Radio, ScanLine, CircleUser, Copy } from "lucide-react";

// Shared destination list for both BottomNav (compact) and Sidebar
// (wide) — same keys/icons/labels, just laid out differently.
//
// Most tabs stay in the nav even when locked (BottomNav/Sidebar show
// them dimmed with a lock badge so the user knows the section
// exists). "copytrading" is the one exception: per product
// requirement, if it isn't in accessibleSections it's left out of
// the nav entirely instead of showing as a locked item.
export function getNavItems(t, accessibleSections) {
  const items = [
    { key: "profile", label: t.nav_profile, icon: CircleUser },
    { key: "signals", label: t.nav_signals, icon: Radio },
    { key: "scanner", label: t.nav_scanner, icon: ScanLine },
    // { key: "live", label: t.nav_live, icon: LineChart },
    { key: "edu", label: t.nav_edu, icon: GraduationCap },
    { key: "copytrading", label: t.nav_copytrade, icon: Copy },
  ];

  if (accessibleSections && !accessibleSections.has("copytrading")) {
    return items.filter((item) => item.key !== "copytrading");
  }
  return items;
}
